import React from "react";
import { FAMA_SUPPORT_EMAIL } from "../utils";
import Folder from "../assets/Folder.png";

export const Unavailable = () => {
  const mailto = `mailto:${FAMA_SUPPORT_EMAIL}`;
  return (
    <div data-testid="unauthorized">
      <div className="flex flex-col gap-6 justify-center items-center pt-4">
        <div className="w-96">
          <img src={Folder} alt="Unavailable" className="w-full" />
        </div>
        <p className="text-5xl font-bold">Page Unavailable</p>
        <p className="text-xl text-stone-800">
          The page you are looking for isn't here right now. Need help?
        </p>
        <p>
          <a
            href={mailto}
            className="inline-block px-6 py-3 bg-green-500 hover:bg-green-600 text-white font-semibold rounded shadow-md transition duration-300 ease-in-out"
          >
            Contact Administrator
          </a>
        </p>
      </div>
    </div>
  );
};
